import { configureStore } from "@reduxjs/toolkit";

import homeReducer from "./reducers/homeSlice";
import utilityReducer from "./reducers/utilitySlice";
import authReducer from "./reducers/authSlice";
import inventoryCategoryReducer from "./reducers/inventoryCategorySlice";
import inventoryTypeReducer from "./reducers/inventoryTypeSlice";
import inventoryBundleReducer from "./reducers/inventoryBundleSlice";
import powerLimitReducer from "./reducers/powerLimitsSlice";
import siteReducer from "./reducers/siteSlice";
import buildingReducer from "./reducers/buildingSlice";
import manufacturerNameReducer from "./reducers/manufacturerNameSlice";
import labNumberReducer from "./reducers/labNumberSlie";
import benchNumberReducer from "./reducers/benchNumberSlice";
import inventoryItemStatusReducer from "./reducers/inventoryItemStatusSlice";
import userGroupsReducer from "./reducers/userGroupsSlice";
import pricePerUnitCurrencyReducer from "./reducers/pricePerUnitCurrencySlice";
import labInventoryReducer from "./reducers/labinventorySlice";
import labInventoryAuditReducer from "./reducers/labInventoryAuditSlice";
import rackAuditReducer from "./reducers/rackAuditSlice";
import notoficationReducer from "./reducers/notificationSlice";
import inventoryProjectReducer from "./reducers/inventoryProjectSlice";
import importDataReducer from "./reducers/importDataSlice";
import chassisManagerReducer from "./reducers/chassisManagerSlice";
import rackManagerReducer from "./reducers/rackManagerSlice";
import rackReducer from "./reducers/rackSlice";
import datacenterReducer from "./reducers/datacenterSlice";
import userActivityReducer from "./reducers/userActivitySlice";
import sWLicensePackageReducer from "./reducers/sWLicensePackageSlice";
import serviceContractReducer from "./reducers/serviceContractSlice";
import pmduPowerReducer from "./reducers/pmduPowerSlice";
import dimmsReducer from "./reducers/dimmsSlice";
import diskReducer from "./reducers/diskSlice";
import nicsReducer from "./reducers/nicsSlice";
import infraDeviceReducer from "./reducers/infraDeviceSlice";
import bladeReducer from "./reducers/bladeSlice";
import jbodReducer from "./reducers/jbodJbofSlice";
import hwReportReducer from "./reducers/hwReportSlice";
import pduReducer from "./reducers/pduSlice";
import fpgaReducer from "./reducers/fpgasSlice";
import procsReducer from "./reducers/procsSlice";
import tpmsReducer from "./reducers/tpmsSlice";
import baasRaasReducer from "./reducers/baasRaasSlice";
import baasRaasReservationRequestsReducer from "./reducers/baasRaasReservationRequestsSlice";
import corsicaReducer from "./reducers/corsicaSlice";
import sustainingReducer from "./reducers/sustainingSlice";
import leasesReducer from "./reducers/leasesSlice";
import benchReservationReducer from "./reducers/benchReservationSlice";
import columnSettingsReducer from "./reducers/columnSettingsSlice";
import notesHistoryReducer from "./reducers/notesHistorySlice";
import themeReducer from "./reducers/themeSlice";
import dialogReducer from "./reducers/dialogSlice";
import selectionReducer from "./reducers/inventorySelectionSlice"
import userReducer from "./reducers//userSlice"
import dropdownReducer from "./reducers/dropdownSlice"
import dropdownReducerId from "./reducers/dropdownSliceId"
import labInventoryLeaseAudit from "./reducers/leaseAuditSlice";

export const store = configureStore({
        reducer: {
                home: homeReducer,
                auth: authReducer,
                utility: utilityReducer,
                inventoryCategory: inventoryCategoryReducer,
                inventoryType: inventoryTypeReducer,
                inventoryBundle: inventoryBundleReducer,
                powerLimit: powerLimitReducer,
                inventoryItemStatus: inventoryItemStatusReducer,
                userGroups: userGroupsReducer,
                corsica: corsicaReducer,
                hwReport: hwReportReducer,
                pricePerUnitCurrency: pricePerUnitCurrencyReducer,
                labInventory: labInventoryReducer,
                labInventoryAudit: labInventoryAuditReducer,
                rackAudit: rackAuditReducer,
                notification: notoficationReducer,

                inventoryProject: inventoryProjectReducer,
                userActivity: userActivityReducer,
                importData: importDataReducer,
                swLicensePackage: sWLicensePackageReducer,
                chassisManager: chassisManagerReducer,
                rackManager: rackManagerReducer,
                rack: rackReducer,
                serviceContract: serviceContractReducer,
                pmduPower: pmduPowerReducer,
                datacenter: datacenterReducer,
                dimms: dimmsReducer,
                disks: diskReducer,
                nics: nicsReducer,
                infraDevice: infraDeviceReducer,
                blade: bladeReducer,
                jbod: jbodReducer,
                pdu: pduReducer,
                fpgas: fpgaReducer,
                procs: procsReducer,
                tpms: tpmsReducer,
                baasRaas: baasRaasReducer,
                baasRaasReservationRequests: baasRaasReservationRequestsReducer,
                allLeases: leasesReducer,
                benchReservation: benchReservationReducer,
                sustaining: sustainingReducer,
                columnSettings: columnSettingsReducer,
                notesHistory: notesHistoryReducer,
                theme: themeReducer,
                dialog: dialogReducer,

                site: siteReducer,
                building: buildingReducer,
                manufacturerName: manufacturerNameReducer,
                benchNumber: benchNumberReducer,
                labNumber: labNumberReducer,
                selection: selectionReducer,
                user: userReducer,
                dropdown: dropdownReducer,
                dropdown_byId: dropdownReducerId,
                labInventoryLeaseAudit:labInventoryLeaseAudit
        },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
